import { request } from './api';

// OTP login. Paths are under the /api/admin/v1 base (see .env.local).

// POST /auth/request-otp {email} -> { message, status, server_ip }
export const requestOtp = (email) =>
  request('/auth/request-otp', { method: 'POST', body: { email } });

// POST /auth/verify-otp {email,otp} -> { token, admin:{id,name,email,role}, status }
export const verifyOtp = (email, otp) =>
  request('/auth/verify-otp', { method: 'POST', body: { email, otp } });
